import styled from 'styled-components'

export type DropdownContainerProps = {
  width?: string
}

export const DropdownContainer = styled.div<DropdownContainerProps>`
  padding: 8px;
  width: ${({ width }) => width || '100%'};

  p {
    white-space: pre-line;
    color: ${(props) => props.theme.colors.black};
  }

  .dropdown-body {
    padding-top: 12px;
  }

  hr {
    border-top: 1px solid ${(props) => props.theme.colors.gray};
  }
`

export const DropdownButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  background-color: transparent;
  border: none;

  img {
    height: auto;
    width: 1.2rem;
  }

  .open-header {
    color: ${(props) => props.theme.colors.primary};
  }

  .open-chevron {
    transform: rotate(180deg);
  }

  &:hover {
    background-color: transparent;
  }

  &:hover p {
    cursor: pointer;
    color: ${(props) => props.theme.colors.primary};
  }
`
